var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var parseConfig = function (config, parent) {
    return config.reduce(function (acc, curr) {
        var currItem = {
            name: curr.name,
            path: curr.path,
            parents: []
        };
        if (parent) {
            currItem = {
                name: curr.name,
                parents: __spreadArrays(parent.parents, [parent]),
                path: parent.path.replace(/\/+$/, '') + "/" + curr.path.replace(/^\/+/, '')
            };
        }
        if (curr.redirect) {
            currItem.redirect = curr.redirect;
        }
        if (curr.guards) {
            currItem.guards = curr.guards;
        }
        if (curr.resourceName) {
            currItem.resourceName = curr.resourceName;
        }
        if (curr.child) {
            return acc.concat(parseConfig(curr.child, currItem), [currItem]);
        }
        acc.push(currItem);
        return acc;
    }, []);
};
//# sourceMappingURL=helpers.js.map